import React, { ComponentProps, FC } from 'react';
import { useBrand } from '../OrganizationContext';
import { LogoComponentType } from './Logo';

const SquareLogo: FC<ComponentProps<LogoComponentType> & { Fallback?: LogoComponentType }> = ({
  Fallback,
  ...props
}) => {
  const {
    SquareLogoComponent,
  } = useBrand();

  if (!SquareLogoComponent) {
    return Fallback ? <Fallback {...props} /> : null;
  }

  return <SquareLogoComponent {...props} />;
};

export default SquareLogo;
